/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'ai-mate.all-chat-view.chat-item.chat-options-button-label': 'Opções de bate-papo para {conversationName}',
  'ai-mate.all-chat-view.chat-item.delete-label': 'Excluir',
  'ai-mate.all-chat-view.chat-item.rename-label': 'Renomear',
  'ai-mate.chat-error-banner.description': 'Seu histórico de bate-papo é salvo por até 30 dias.',
  'ai-mate.chat-error-banner.title': 'Iniciar novo bate-papo',
  'ai-mate.chat-error.description': 'Tente <btn>recarregar o bate-papo</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Você atingiu o número máximo de solicitações. Tente de novo mais tarde.',
  'ai-mate.chat-error.rate-limited-title': 'Muitas solicitações',
  'ai-mate.chat-error.rovo-inactive-description':
    'Parece que o Rovo não está habilitado no site. <link>Configurar o Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'O Rovo está inativo',
  'ai-mate.chat-error.title': 'A gente não sabe o que deu errado',
  'ai-mate.chat-input.file-close-icon-label': 'Remover arquivo',
  'ai-mate.chat-input.file-error-icon-label': 'Erro ao carregar arquivo',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Excluir',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label':
    'Opções de bate-papo para {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Renomear',
  'ai-mate.common.ui.expandable-section.collapse': 'Recolher',
  'ai-mate.common.ui.expandable-section.expand': 'Expandir',
  'ai-mate.conversation-assistant-page-selector.page-selector-label': 'Selecionar página',
  'ai-mate.conversation-assistant-space-selector.space-selector-label': 'Selecionar espaço',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Cancelar',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'A conversa que você está tentando excluir não existe.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Excluir',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Excluir conversa "{name}"?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Ocorreu um erro ao excluir a conversa. Tente de novo.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Tem certeza de que quer excluir essa conversa? A ação não pode ser desfeita.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Cancelar',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'O canal que você está tentando editar não existe.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Nome',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Ocorreu um erro ao editar a conversa. Tente de novo.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Editar conversa',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'O nome é o mesmo que o nome atual.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Salvar',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {{results,number} resultado encontrado} other {{results,number} resultados encontrados}}',
  'ai-mate.conversation-list-view.back-button.label': 'Voltar',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Fechar bate-papo',
  'ai-mate.conversation-list-view.header-title': 'Histórico de bate-papo',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Novo bate-papo',
  'ai-mate.conversation-list-view.no-chat': 'Sem resultados',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Pesquisar bate-papos',
  'ai-mate.expander.hide-details': 'Ocultar informações',
  'ai-mate.expander.show-details': 'Mostrar mais informações',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Fechar bate-papo',
  'ai-mate.main-chat.hamburger-menu-label': 'Menu',
  'ai-mate.main-chat.maximize-chat-button-label': 'Tela cheia',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restaurar visualização',
  'ai-mate.main-chat.new-chat-button-label': 'Novo',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Novo bate-papo',
  'ai-mate.rovo-chat-header.back-home-button-label': 'Ir para a página inicial',
  'ai-mate.rovo-chat-header.close-chat-header-button-label': 'Fechar',
  'ai-mate.rovo-chat-header.debug-button-label': 'Depurar',
  'ai-mate.rovo-chat-header.debug-icon-label': 'Depurar',
  'ai-mate.rovo-chat-header.delete-button-text': 'Excluir',
  'ai-mate.rovo-chat-header.delete-icon-label': 'Excluir',
  'ai-mate.rovo-chat-header.feedback-button-text': 'Feedback',
  'ai-mate.rovo-chat-header.feedback-icon-label': 'Feedback',
  'ai-mate.rovo-chat-header.floating-button-text': 'Flutuante',
  'ai-mate.rovo-chat-header.floating-icon-label': 'Flutuante',
  'ai-mate.rovo-chat-header.fullscreen-button-text': 'Tela cheia',
  'ai-mate.rovo-chat-header.fullscreen-icon-label': 'Tela cheia',
  'ai-mate.rovo-chat-header.get-help-button-text': 'Obter ajuda',
  'ai-mate.rovo-chat-header.get-help-icon-label': 'Obter ajuda',
  'ai-mate.rovo-chat-header.menu-button-label': 'Menu',
  'ai-mate.rovo-chat-header.more-menu-button-label': 'Mais',
  'ai-mate.rovo-chat-header.new-agent-chat-button-label': 'Novo bate-papo com {agentName}',
  'ai-mate.rovo-chat-header.new-chat-button-label': 'Novo bate-papo',
  'ai-mate.rovo-chat-header.rename-button-text': 'Renomear',
  'ai-mate.rovo-chat-header.rename-icon-label': 'Renomear',
  'ai-mate.rovo-chat-header.sidebar-button-text': 'Barra lateral',
  'ai-mate.rovo-chat-header.sidebar-icon-label': 'Barra lateral',
  'ai-mate.rovo-chat-header.switch-mode-button-label': 'Alternar para',
  'ai-mate.rovo-chat-header.switch-mode-section-text': 'Alternar para',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'conversation-assistant-message-actions.require-information-tool.project-selector.header': 'Selecione um projeto',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Enviar',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Pergunte ao Atlassian Intelligence sobre isso',
  'highlight-actions.rovo-chat-explain-option.text': 'Explique',
  'highlight-actions.rovo-chat-explain-prompt':
    'Explique isso usando outras palavras e incluindo mais informações, mas com uma linguagem bem simples e frases curtas. Dê exemplos e inclua definições para as terminologias técnicas usadas na frase original.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Procurar recursos',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Descubra recursos apenas com conhecimentos organizacionais que corroborem com a declaração feita.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Dê exemplos',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Dê exemplos disto em recursos organizacionais ou conhecimento público. Se não houver recursos para oferecer, tente fazer uma metáfora para exemplificar e ajudar alguém a entender melhor.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Enviar feedback',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Dê feedback analisando a formulação disto. Faça comentários sobre a escolha de palavras, a gramática e a pontuação. Seja positivo e empolgado, mas sempre aponte pelo menos uma coisa que precisa ser melhorada ou alterada.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recomendações de bate-papo',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Abrir bate-papo',
  'highlight-actions.rovo-chat-summarize-option.text': 'Resumir',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Destaque os principais pontos disto. Foque em informações essenciais e descarte dados desnecessários. Ofereça uma visão geral concisa em um único parágrafo.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Pergunte no Chat',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Faça uma pergunta sobre isso.',
  'horizontal-scroll-container.scroll-left': 'Rolar para a esquerda',
  'horizontal-scroll-container.scroll-right': 'Rolar para a direita',
  'rovo-chat.deep-research-spotlight.description':
    'Ative o Deep Research e digite um prompt. A Rovo vai criar um plano, conduzir a pesquisa e gerar um relatório completo.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Ignorar',
  'rovo-chat.deep-research-spotlight.heading': 'Pesquisa avançada no Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Arraste e solte para adicionar contexto',
  'rovo-chat.message-file.icon-label': 'Arquivo',
  'rovo-chat.rovo-greeting.deep-research-greeting-text': 'Pergunte algo para saber mais',
  'rovo-chat.rovo-greeting.default-greeting-text': 'Como posso ajudar, {name}?',
  'rovo-chat.search-input.screen-reader-prompt':
    'Digitar qualquer caractere neste campo vai atualizar os resultados da pesquisa abaixo',
};
